$(document).ready(function () {
  // Sort elements based on data-sort
  $(".circle-slider").each(function () {
    let slides = $(this).find(".single-slide");
    slides.sort(function (a, b) {
      let sortA = parseFloat($(a).attr("data-sort")) || Infinity;
      let sortB = parseFloat($(b).attr("data-sort")) || Infinity;
      return sortA - sortB;
    });

    $(this).append(slides); // Re-append slides in sorted order
  });

  let $slider = $(".circle-slider");

  $slider.slick({
    slidesToShow: 13.5,
    slidesToScroll: 4,
    arrows: true,
    dots: false,
    infinite: false,
    cssEase: "linear",
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 9.5 } },
      { breakpoint: 1300, settings: { slidesToShow: 8.5 } },
      { breakpoint: 1025, settings: { slidesToShow: 6.5 } },
      { breakpoint: 900, settings: { slidesToShow: 5.5 } },
      { breakpoint: 600, settings: { slidesToShow: 4.5, slidesToScroll: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 3.5, slidesToScroll: 2 } },
      { breakpoint: 380, settings: { slidesToShow: 3.5, slidesToScroll: 2 } },
    ],
  });

  // Function to update center slide in real-time
  function updateCenterSlide() {
    let $slides = $slider.find(".slick-slide");
    let sliderWidth = $slider.width();
    let centerX = sliderWidth / 2;

    $slides.each(function () {
      let slide = $(this);
      let slideOffset = slide.offset().left - $slider.offset().left;
      let slideWidth = slide.outerWidth(true);
      let slideCenter = slideOffset + slideWidth / 2;

      if (Math.abs(slideCenter - centerX) < slideWidth / 2) {
        slide.addClass("center-slide");
      } else {
        slide.removeClass("center-slide");
      }
    });

    requestAnimationFrame(updateCenterSlide);
  }

  requestAnimationFrame(updateCenterSlide);

  // Check if the current page is a collection page
  const isCollectionPage = document.body.dataset.template === "collection";

  if (isCollectionPage) {
    const buttons = document.querySelectorAll(".custom-btn");
    const productGrid = document.getElementById("CollectionProductGrid");
    const localStorageKey = "activeButtonId";

    const setActiveButton = (buttonId) => {
      buttons.forEach((button) => button.classList.toggle("active", button.id === buttonId));
      productGrid.className = buttonId === "c-product-btn" ? "c-product-btn" : "c-lifestyle-btn";
      localStorage.setItem(localStorageKey, buttonId);
    };

    buttons.forEach((button) => button.addEventListener("click", () => setActiveButton(button.id)));

    const savedButtonId = localStorage.getItem(localStorageKey) || "c-product-btn";
    setActiveButton(savedButtonId);
  }

  // Footer accordion for mobile view
  $(".footer-top .footer-item__title").on("click", function () {
    let parent = $(this).closest(".footer-item");
    parent.find(".icon--plus, .icon--minus").toggleClass("hidden");
    parent.find(".footer-item__menu").toggleClass("active");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let observer;
  let reviewContainer;
  const MAX_RETRIES = 3;
  let retryCount = 0;

  // Enhanced logger
  function log(message, data = null) {
    console.log(`[Review Images] ${message}`, data || '');
  }

  function warn(message, error = null) {
    console.warn(`[Review Images] ${message}`, error || '');
  }

  async function fetchProductData(productHandle) {
    try {
      log(`Fetching product data for handle: ${productHandle}`);
      const response = await fetch(`/products/${productHandle}.json`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      log(`Successfully fetched product data for ${productHandle}`);
      return data.product;
    } catch (error) {
      warn(`Error fetching product data for ${productHandle}: ${error.message}`);
      return null;
    }
  }

  async function addProductImagesToReviews(parent = document) {
    try {
      const reviews = parent.querySelectorAll(".jdgm-rev:not([data-image-loaded])");
      log(`Found ${reviews.length} unprocessed reviews in parent`, parent);

      for (const [index, review] of reviews.entries()) {
        log(`Processing review ${index + 1}/${reviews.length}`);
        
        let productUrl = review.getAttribute("data-product-url") || 
          review.querySelector(".jdgm-rev__prod-link")?.href?.split("#")[0];

        if (!productUrl) {
          warn("Skipping review - no product URL found", review);
          continue;
        }

        // Improved handle extraction with URL normalization
        const handleMatch = productUrl.match(/products\/([^\/?#]+)/i);
        if (!handleMatch) {
          warn("Invalid product URL format", productUrl);
          continue;
        }
        
        let productHandle = handleMatch[1];
        log(`Extracted product handle: ${productHandle}`);

        let productData = await fetchProductData(productHandle);
        let usedRedirect = false;

        // Handle redirects
        if (!productData) {
          log(`Trying redirect resolution for ${productUrl}`);
          try {
            const response = await fetch(productUrl, { redirect: "follow" });
            
            if (response.redirected) {
              const redirectedUrl = new URL(response.url);
              log(`Redirected to: ${redirectedUrl.href}`);
              
              const newHandleMatch = redirectedUrl.pathname.match(/products\/([^\/]+)/i);
              if (newHandleMatch) {
                productHandle = newHandleMatch[1];
                log(`New handle from redirect: ${productHandle}`);
                productData = await fetchProductData(productHandle);
                usedRedirect = true;
              }
            }
          } catch (error) {
            warn("Redirect handling failed", error);
          }
        }

        if (productData?.images?.length) {
          try {
            const productImageUrl = productData.images[0].src;
            log(`Creating image elements for ${productImageUrl}`);

            // Create DOM elements
            const wrapper = document.createElement("div");
            wrapper.className = "jdgm-rev-wrapper";

            const imageColumn = document.createElement("div");
            imageColumn.className = "jdgm-rev-image-column";

            const link = document.createElement("a");
            link.className = "jdgm-rev-product-link";
            link.href = productUrl;
            link.target = "_blank";

            const img = document.createElement("img");
            img.className = "jdgm-rev-product-img";
            img.src = productImageUrl;
            img.alt = "Product Image";
            
            // Add image error handling
            img.onerror = () => warn("Image failed to load", productImageUrl);

            // Build structure
            link.appendChild(img);
            imageColumn.appendChild(link);
            
            const contentColumn = document.createElement("div");
            contentColumn.className = "jdgm-rev-content-column";
            
            while (review.firstChild) {
              contentColumn.appendChild(review.firstChild);
            }

            wrapper.append(imageColumn, contentColumn);
            review.appendChild(wrapper);
            review.setAttribute("data-image-loaded", "true");
            log("Successfully added product image");

          } catch (domError) {
            warn("DOM manipulation error", domError);
          }
        } else {
          warn("Product data missing or no images available", productData);
        }
      }
    } catch (error) {
      warn("Critical error in addProductImagesToReviews", error);
    }
  }

  // Improved observer setup
  function initObserver() {
    reviewContainer = document.querySelector(".jdgm-rev-widg__reviews");
    
    if (reviewContainer && !observer) {
      observer = new MutationObserver(mutations => {
        log(`Processing ${mutations.length} mutations`);
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.matches(".jdgm-rev")) {
              log("New review node detected", node);
              addProductImagesToReviews(node);
            }
          });
        });
      });

      observer.observe(reviewContainer, {
        childList: true,
        subtree: true,
        attributes: false
      });
      log("MutationObserver initialized");
    }
  }

  // Enhanced load more handling
  document.addEventListener("click", async (event) => {
    if (event.target.closest(".jdgm-paginate__load-more")) {
      log("Load More button clicked");
      retryCount = 0;
      
      const checkInterval = setInterval(async () => {
        const newReviews = document.querySelectorAll(".jdgm-rev:not([data-image-loaded])");
        
        if (newReviews.length > 0 || retryCount >= MAX_RETRIES) {
          clearInterval(checkInterval);
          if (newReviews.length) {
            log(`Processing ${newReviews.length} new reviews after load`);
            await addProductImagesToReviews(document.body);
          }
        } else {
          retryCount++;
          log(`Retry check ${retryCount}/${MAX_RETRIES}`);
        }
      }, 1000);
    }
  });

  // Initial setup
  initObserver();
  addProductImagesToReviews();

  // Safety check for container changes
  setInterval(initObserver, 5000);
});